module.exports = __webpack_public_path__ + "media/img/uploads/device-demonstration-01-aa3ed3ce2bdcd4507bed3f9c768795d0.png";